import { useContext } from 'react';
import _get from 'lodash/get';

import { AuthContext } from 'context/AuthContext';

export default function useStoreCurrency() {
  const { storeProperties } = useContext(AuthContext);
  return _get(storeProperties, 'store_currency', null);
}
